import React, {useState, useEffect, useRef,forwardRef, useImperativeHandle} from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './index.scss';
import StatesService from '../../../utils/states';
import CountryService from '../../../utils/country';
import Form, {Item,SimpleItem, RequiredRule, Label} from 'devextreme-react/form';
import DataSource from 'devextreme/data/data_source';
import AddressApi from '../../../api/address';
import AccShipping from '../shipments-config/acc-shipping';

const OrderDetailsView = forwardRef(({data},ref) => {
    //console.log("data",data);
    var orderData = data;
    const [countryValue, setCountryValue] = useState('');

    const priceFormat  = (currency,price) => {
        var curr = currency? currency: 'USD';
        return AddressApi.getSymbolbyCurrencyName(curr) + price;
    }
    const currencyFormat = () => {
        var curr = orderData?.currency? AddressApi.getSymbolbyCurrencyName(orderData.currency):AddressApi.getSymbolbyCurrencyName("USD");
        return `${curr} #,##0.##;(${curr} #,##0.##)`
    }

    const country = new DataSource({
        store: {
            type: 'array',
            data: CountryService,
            key: 'iso2'
        },
        pageSize: 10,
        paginate: true
    });
    const CountryOnChange = ({value}) => {
        setCountryValue(value);
        //console.log(countryValue);
    }

    const state = new DataSource({
        store: {
            data: StatesService,
            type: 'array',
            key: 'name'
        },
        filter: [
            "country_code", "=", countryValue
        ],
        pageSize: 10,
        paginate: true
    });

    const ItemLists = ({data}) => {
        var sku = data.sku;
        var currency = data.currency;
        const items = sku?.map(item=>{
            var price = item.price;
            return(
                <div key={item._id} className={'flex flex-row'}>
                      <div className={'item-name'}>{item.name} - {item.sku}</div>
                      <div className={'item'}>{item.quantity}</div>
                      <div className={'item'} >{priceFormat(currency,price)}</div>
                </div>
            )
        });
        
        const priceTotal = ()=>{
            var totalPrice = sku?.reduce(function(total, item) { return total + item.price; }, 0);
            var result = priceFormat(currency,totalPrice);
            return result;
        }
    

        const quantityTotal = sku?.reduce(function(total, item) { return total + item.quantity; }, 0)

        return (
            <div>
                <div className={'grid-item'}>
                    <div className={'flex flex-row'}>
                        <div className={'item-name'}><b>Item</b></div>
                        <div className={'item'}><b>Quantity</b></div>
                        <div className={'item'}><b>Price</b></div>
                    </div>
                    {items}
                </div>
                <hr/>
                <div>
                    <div className={'flex flex-row'}>
                        <div className={'item-name'}>Total</div>
                        <div className={'item'}>{quantityTotal} items</div>
                        <div className={'item'}>{priceTotal()}</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <ScrollView>
                <div className="detail-view flex flex-row">
                    <div className={'detail-information'}>
                        <div className={'detail-order'}>
                            <div className={'title'}>Order Information</div>
                            <Form formData={data} colCount={3}>
                                <SimpleItem dataField={'orderNo'} editorOptions={{stylingMode: 'outlined', readOnly:true}}/>
                                <SimpleItem dataField={'status'} editorOptions={{ stylingMode: 'outlined', readOnly:true}}/>
                            </Form>
                        </div>
                        <div className={'detail-recipient'}>
                            <div className={'title'}>Customer Information</div>
                            <Form formData={orderData} colCount={3}>
                            <SimpleItem dataField={'name'} editorOptions={{readOnly:true}}>
                                    <RequiredRule message="name is required"/>
                                </SimpleItem>
                                <SimpleItem dataField={'email'} editorOptions={{readOnly:true}}/>
                                <SimpleItem dataField={'phone'} editorOptions={{readOnly:true}}/>
                                <SimpleItem dataField={'addressLine1'} colSpan={3} editorOptions={{readOnly:true}}>
                                    <RequiredRule message="addressLine1 is required"/>
                                </SimpleItem>
                                <SimpleItem dataField={'city'} editorOptions={{readOnly:true}}/>
                                <Item
                                    dataField="state"
                                    editorType="dxSelectBox"
                                    editorOptions={{
                                    dataSource: state,
                                    searchEnabled: true,
                                    displayExpr: 'name',
                                    valueExpr: 'name',
                                    readOnly:true
                                }}>
                                <RequiredRule message="state is required"/>
                                </Item>
                                 <Item
                                    editorType={'dxSelectBox'}
                                    dataField="country"
                                    editorOptions={{
                                    dataSource: country,
                                    searchEnabled: true,
                                    displayExpr: 'name',
                                    valueExpr: 'iso2',
                                    onValueChanged: CountryOnChange,
                                    readOnly:true
                                }}>
                                <RequiredRule message="country is required"/>
                                </Item>
                                <SimpleItem dataField={'zipCode'} editorOptions={{ }}>
                                    <RequiredRule message="zipcode is required"/>
                                </SimpleItem>
                                <Item
                                    editorType={'dxNumberBox'}
                                    dataField="shippingPaid"
                                    editorOptions={{
                                    readOnly:true,
                                    format: currencyFormat
                                }}/>
                                <Item
                                    editorType={'dxNumberBox'}
                                    dataField="taxPaid"
                                    editorOptions={{
                                    readOnly:true,
                                    format: currencyFormat
                                }}/>
                                <Item
                                    editorType={'dxNumberBox'}
                                    dataField="totalPaid"
                                    editorOptions={{
                                    readOnly:true,
                                    format: currencyFormat
                                }}/>
                            </Form>
                        </div>
                        <div className={'detail-recipient'}>
                            <div className={'title'}>Item Information</div>
                            <ItemLists data={data}/>
                        </div>
                    </div>
                    <div className={'detail-shipments'}>
                        <AccShipping data={data}/>
                    </div>
                </div>
            </ScrollView>
        </React.Fragment>

    );
});

export default OrderDetailsView;